import AudioPlayer from '../audio/main';
import SystemUtils from '../utils/system';


export default class ParentModal {
    
    constructor() {
        this.$self = document.querySelector('.js-parent-modal');
        this.soundAssets = {};
        this._init();
    }


    render(){
        this.sound.playOne('na1');
        this.$self.classList.add('-active');
    }


    _init(){
        const ext = window.navigator.userAgent.match(/Android/) ? ".ogg" : ".mp3"; 
        this.soundAssets['na1'] = {src:[`./assets/audio/parent_modal/na1${ext}`]};

        this.sound = new AudioPlayer(this.soundAssets);
        this.sound.load();
    }
}
